confirmMessage = function(message) {
    if (!confirm(message)) {
        this.event.preventDefault();
    }
};

window.copy = function(data) {
    return JSON.parse(JSON.stringify(data));
};

window.generateUID = function () {
    return '_' + Math.random().toString(36).substr(2, 9);
};
